module.exports = __webpack_public_path__ + "static/media/credit-note-posting.3ae39ae1.svg";